<template lang="html">
  <v-dialog v-model="dialog" width="650" height="auto">
    <v-btn v-if="check == 'small'" flat icon color="indigo" slot="activator">
      <v-icon>search</v-icon>
    </v-btn>
    <v-btn
      v-else
      slot="activator"
      color="blue darken-1"
      outline
    >
      ดูสินค้าเพิ่มเติม
    </v-btn>
    <v-card>
      <v-card-title class="grey lighten-2" style="font-size:26px" primary-title>
        {{ data.name }}
      </v-card-title>
      <div align="center">
        <v-img
          v-if="data.url === ''"
          :src="require('@/assets/no-product.png')"
          :lazy-src="require('@/assets/no-product.png')"
          aspect-ratio="1"
          max-height="450"
          contain
          class="white"
        >
          <v-layout
            slot="placeholder"
            fill-height
            align-center
            justify-center
            ma-0
          >
            <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
          </v-layout>
        </v-img>
          <v-img
            v-else
            :src="data.url"
            :lazy-src="data.url"
            aspect-ratio="1"
            max-height="450"
            contain
            class="white"
          >
            <v-layout
              slot="placeholder"
              fill-height
              align-center
              justify-center
              ma-0
            >
              <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
            </v-layout>
          </v-img>
      </div>
      <v-card-text>
        <v-layout v-if="isMobile" justify-center row>
          <v-flex xs6>
            <v-layout column>
              <v-flex v-if="data.name" class="pb-3 pl-2" xs12>
                <b>ชื่อสินค้า: </b>{{ data.name }}
              </v-flex>
              <v-flex v-if="data.code" class="pb-3 pl-2" xs12>
                <b>รหัส: </b>{{ data.code }}
              </v-flex>
              <v-flex v-if="data.size" class="pb-3 pl-2" xs12>
                <b>ขนาด: </b>{{ data.size }}
              </v-flex>
              <v-flex v-if="data.color" class="pb-3 pl-2" xs12>
                <b>สี: </b>{{ data.color }}
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs6>
            <v-layout column>
              <v-flex v-if="data.workMessage" class="pb-3" xs12>
                <b>การใช้งาน: </b>{{ data.workMessage }}
              </v-flex>
              <v-flex v-if="data.message" class="pb-3" xs12>
                <b>หมายเหตุ: </b>{{ data.message }}
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout v-else justify-center row>
          <v-flex xs6>
            <v-layout column>
              <v-flex v-if="data.name" class="pb-3 pl-2" xs12 style="font-size:16px">
                <b>ชื่อสินค้า: </b>{{ data.name }}
              </v-flex>
              <v-flex v-if="data.code" class="pb-3 pl-2" xs12 style="font-size:16px">
                <b>รหัส: </b>{{ data.code }}
              </v-flex>
              <v-flex v-if="data.size" class="pb-3 pl-2" xs12 style="font-size:16px">
                <b>ขนาด: </b>{{ data.size }}
              </v-flex>
              <v-flex v-if="data.color" class="pb-3 pl-2" xs12 style="font-size:16px">
                <b>สี: </b>{{ data.color }}
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs6>
            <v-layout column>
              <v-flex v-if="data.workMessage" class="pb-3" xs12 style="font-size:16px">
                <b>การใช้งาน: </b>{{ data.workMessage }}
              </v-flex>
              <v-flex v-if="data.message" class="pb-3" xs12 style="font-size:16px">
                <b>หมายเหตุ: </b>{{ data.message }}
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="dialog = false">
          ปิดหน้าต่าง
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['data', 'check'],
  data () {
    return {
      dialog: false,
      isMobile: false,
      panel: [true, true, true, true, true, true]
    }
  },
  mounted () {
    this.isMobile = window.innerWidth < 600
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/productDialog.vue